import {
  removeItemFromCart,
  getCartDetails,
  addItemsToCart,
  updateItemsInCart,
  updateUserCartData
} from 'aster-foundation/core/epharmacy/Cart/redux/actions';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Button } from 'react-bootstrap';
import Image from 'next/image';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { IC_CART , IC_NEW_INCREASE_PRODUCT, IC_NEW_DECREASE_PRODUCT, IC_REMOVE, IC_CART_OPTICS, IC_DOWNLOAD_GREEN_ROUND } from '@common/Assets/images';
import { checkAndUpdateOldCartId, destructureAndGetCurrentCartItemsList, errorHandlingEpharmacy, MAX_QTY_ADD_TO_CART_PER_ORDER, MIN_MOBILE_WIDTH } from '@common/Utility/common-utils';
import {
  ADD_TO_CART_ERROR_MESSAGE,
  ADD_TO_CART_MESSAGE,
  ASTER_PRODUCT_AVAILABILITY,
  ONLINE_PHARMACY_ROUTE,
  OUT_OF_STOCK_ERROR_MESSAGE,
  LOCALSTORAGE_KEYS,
  CART_TYPES,
  MY_CART_ROUTE,
  FLAGSMITH_KEYS,
  SESSION_STORAGE_KEYS,
} from '@common/Utility/constants';
import { EventEmitter } from '@common/Utility/eventEmitter';
import { getCurrency, getPage } from '@common/Constants/analytics';
import { setProductItemQtyMultiple } from '../ProductDetails/redux/reducer';
import { dataLayerSendEvent, getProductItemObjectAddToCartEvent, getProductItemObjectEventFillersOptics, getProductItemObjectEventFillersSelect, sendRemoveFromCartEvent } from '../EpharmacyAnalytics';
import { setTotalQtyData } from '../MyCart/redux/reducer';
import { ButtonBase, DropdownControl } from '@common/Component/Forms';
import { searchTermInsertion, searchTermProductInsertion } from 'aster-foundation/core/epharmacy/search/redux/actions';
import { useRouter } from 'next/router';
import BundleOfferSideBar from '@common/Component/BundleOfferSideBar/BundleOfferSideBar';
import NotifyMe from './NotifyMe';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { flagsmith } from '@common/Lib/Flagsmith';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';
import { useTranslation } from '@common/i18n';

/**
 * @param {*} isProductDetails param will use to show/hide small DropdownControl (Coming from ProductDetails component).
 * @param {*} availableStock param will use to control the limit of the quantities item that is coming from the catalog.
 * @param {*} sku param will use to send in addToCart API parameter.
 * @param {*} outOfStock param will use to send in updateProductQauntity API parameter.
 * @description AddToCart is the common component it will use for handle add to cart functionality.
 * @returns Add to cart component.
 */
const AddToCart = ({
  isProductDetails,
  availableStock,
  sku,
  outOfStock,
  product,
  pageType,
  size,
  enableFullWidth,
  isFloat,
  minWidth,
  sectionName,
  itemListId,
  itemListName,
  index,
  getProductIndex,
  checkIfInCart,
  setShowUpselling,
  isFirstElement,
  BundleDetails,
  isBundle,
  BundleImage,
  bundleflag,
  productDetails,
  setErrors,
  errors,
  pageId,
  referrerpage,
  productName,
  screenName,
  price,
  setFbt_addedtocart,
  setFilleraddedtocart,
  FBTProduct,
  referrerPage,
  newButton,
  isOptics,
  shouldNotShowBundle = false,
  emptySphValues = () => {}
}) => {
  /**
   * @description Here we have declare initial variable's.
   */
  const dispatch = useDispatch();
  const router = useRouter();
  const generateURL = useNavigationURL();
  const t = useTranslation()
  const reducerItems = useSelector((state) => state?.app?.pdpReducer?.items);
  const [selectedCartItem, setSelectedCartItem] = React.useState(0);
  const [BundleOffer, setBundleOffer] = React.useState(null);
  const [closeBundle, setcloseBundle] = React.useState(false);
  const [bundleAddToCart, setBundleAddToCart] = useState(false);
  const [dropdown2, setDropdown2] = React.useState(true);
  const [failedToCart, setFailedToCart] = useState(false);
  const [valueDropDown, setvalueDropDown] = React.useState(null);

  const zoneData = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const userZoneData = useSelector((state) => state?.epharmacy?.updateUserZone?.data?.additionalInfo)
  const cartData = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);
  const getCartV2Data = useSelector((state) => state?.epharmacy?.getCartDetails?.data?.body);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const myCartTotalItems = useSelector((state) => state?.app?.myCartReducer?.totalItems);
  const [cartButtonLoading, setCartButtonLoading] = React.useState(false);
  const [itemQuantity, setItemQuantity] = React.useState([]);
  const [showBundleSidebar, setShowBundleSidebar] = React.useState(false);
  const [fromBundleComponent, setfromBundleComponent] = React.useState(false);
  const myShoppingList = useSelector((state) => state?.app?.myShoppingListReducer);
  const wishListSkuIds = (myShoppingList?.wishList || [])?.map(listItem => listItem?.sku);

  const ae_common_api_actions = flagsmith.getValue(FLAGSMITH_KEYS?.COMMON_API_ACTION, { json: true });
  const enableXUserVcpId = ae_common_api_actions?.xUserVcpId || false;

  const productHasVariants = product?.extensionAttributes?.variantData?.length > 0;
  const isMyCartPage = router?.pathname?.indexOf(MY_CART_ROUTE) > -1;

  // set qty from reducer first load
  const bundlequantity = BundleDetails?.bundles?.map((bundle) => bundle?.quantity);
  const lastQuantity = bundlequantity?.[bundlequantity.length - 1];

  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

  useEffect(() => {
    let qtyTemp = 0;
    if (reducerItems) {
      const currentItem = reducerItems?.filter((item) => {
        if(sku?.isDifferentSPH || sku?.leftOrDefault) {
          if (sku?.isDifferentSPH) {
            return item?.item_id === sku?.right?.sku;
          }
          return item?.item_id === sku?.leftOrDefault?.sku;
        }
        return item?.item_id === sku
    });
      if (currentItem?.length > 0) {
        qtyTemp = currentItem?.[0]?.qty;
      }
    }
    setSelectedCartItem(qtyTemp);
  }, [sku, reducerItems]);

  const triggerSearchtermApi = (product) => {
    const reqParams = {
      searchKeyword: product?.name,
      categoryName: product?.categoryName || '',
      searchFilterKey: '',
      type: product?.type || '',
      moduleType: 'Epharmacy',
      specialization: product?.specialization || '',
      id: product?.productId || '',
      uriPath: '',
      zone: localStorage.getItem('userZone'),
    };
    dispatch(
      searchTermInsertion({
        params: reqParams,
        onSuccess: (response) => {
          const params = {
            correlationId: response?.correlationId,
            clickedOn: product?.sku,
            clickType: 'ADD_TO_CART',
            type: 'products',
            moduleType: 'Epharmacy',
          };
          dispatch(
            searchTermProductInsertion({
              params: params,
              onSuccess: (response) => {},
              onFailure: (err) => {
                const errAnalyticsParams = getCommonAnalyticsParams();
                errorHandlingEpharmacy(err, true,errAnalyticsParams?.screenName, errAnalyticsParams?.pageType);
              },
            }),
          );
        },
        onFailure: (err) => {
          const errAnalyticsParams = getCommonAnalyticsParams();
          errorHandlingEpharmacy(err, true,errAnalyticsParams?.screenName, errAnalyticsParams?.pageType);        },
      }),
    );
  };

  /**
   * @description Here we are controlling the limit of the quantities that is coming from the catalog.
   */
  React.useEffect(() => {
    const tempArr = [];
    const qtyLength =
      Number(availableStock) > MAX_QTY_ADD_TO_CART_PER_ORDER ? MAX_QTY_ADD_TO_CART_PER_ORDER : Number(availableStock);
    for (let index = 0; index < qtyLength; index++) {
      tempArr.push(index + 1);
    }
    setItemQuantity(tempArr);
  }, [availableStock]);

  /**
   * @description Here we have declare getCartInfos API to get cart details.
   */
  const getCartInfos = () => {
    const { page } = getPage(router?.asPath);
    const params = {
      cartId: cartData?.cart_id,
      "cart_type": CART_TYPES.AE,
      "merge_shipment": false,
      page,
    };
    if(enableXUserVcpId){
      params.userId = userLogin?.id
    }
    if (userZoneData) {
      params.zones = encodeURIComponent(JSON.stringify(userZoneData));
    }
    
    dispatch(
      getCartDetails({
        param: params,
        onSuccess: (response) => {
          if (response?.delivery_groups) {
            dispatch(setProductItemQtyMultiple(destructureAndGetCurrentCartItemsList(response)));
          }
          if (wishListSkuIds?.find((wsku) => wsku === sku)) {
            EventEmitter.dispatch('fetchWishList', {zone: userZoneData, userLogin});
          }
          dispatch(setTotalQtyData(response?.total_quantity));
          if (isMyCartPage === true) {
            setCartButtonLoading(false);
          }
        },
        onFailure: (err) => {
          setCartButtonLoading(false);
          const errAnalyticsParams = getCommonAnalyticsParams();
          errorHandlingEpharmacy(err, true,errAnalyticsParams?.screenName, errAnalyticsParams?.pageType);
        },
      }),
    )
  
  };
  /**
   * @description Here we will send event to analytics data to tag manager.
   */

  const getBadgeContent = () =>{
    const asterBadge = product?.badgeDetails?.asterBadge;
    const lowestPriceLabel = product?.lowestPriceLabel;

    let badgeContents = [];

    if (Array.isArray(asterBadge)) {
      badgeContents = asterBadge?.map((badge) => badge.content);
    } else if (asterBadge) {
      badgeContents = [asterBadge.content];
    }

    const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
    if (formattedLowestPriceLabel) {
      badgeContents.push(formattedLowestPriceLabel);
    }
    return badgeContents;
  }

  const getCommonAnalyticsParams = () => {
    if (typeof window === 'undefined') return { screenName: '', pageType: '' };
    return { screenName: screenName || sessionStorage.getItem('screenName'), pageType: pageType || sessionStorage.getItem('pageType') };
  };

  const getEventParams = (type,qty) => {
    const serializedAppointment = JSON.parse(sessionStorage.getItem('serializedAppointment'));
    const page_type= sessionStorage.getItem('pageType');
    const screen_name= sessionStorage.getItem('screenName');
    const referrer_page = sessionStorage.getItem('referrerPage');
    let productSku = [];
    if(type === "optics") {
      productSku.push(sku?.leftOrDefault?.sku);
      if(sku?.isDifferentSPH) {
        productSku.push(sku?.right?.sku);
      }
    } else {
      productSku.push(product?.sku);
    }

    let badgeContents = getBadgeContent();
    let productsArr = [];
    let productLeft = product;
    let productRight = product;
    if(type === 'optics') {
      productLeft['price'] = product?.extensionAttributes?.variantData?.[0]?.variants?.[sku?.leftOrDefault?.id]?.productData?.price;
      productLeft['specialPrice'] = product?.extensionAttributes?.variantData?.[0]?.variants?.[sku?.leftOrDefault?.id]?.productData?.specialPrice;
      productLeft['item_id'] = sku?.leftOrDefault?.sku;
      productsArr.push(productLeft);
      if(sku?.isDifferentSPH) {
        productRight['price'] = product?.extensionAttributes?.variantData?.[0]?.variants?.[sku?.right?.id]?.productData?.price;
        productRight['specialPrice'] = product?.extensionAttributes?.variantData?.[0]?.variants?.[sku?.right?.id]?.productData?.specialPrice;
        productRight['item_id'] = sku?.right?.sku;
        productsArr.push(productRight);
      }
    } else {
      productsArr.push(product);
    }

    const params = {
      ecommerce: {
        items: type === 'optics' 
          ? [{ ...getProductItemObjectEventFillersOptics(productsArr)}] 
          : [
            {
              ...getProductItemObjectAddToCartEvent(product), 
              quantity: parseFloat(qty),
            },
          ],
      },
      section_name:
      sectionName === 'Product Details Page - FBT' ||
      sectionName === 'Product Details Page' ||
      sectionName === 'Product Listing page'
        ? null
        : sectionName,
      screen_name: screen_name ? screen_name : screenName,
      page_type: page_type ? page_type : pageType?.toLowerCase(),
      product_sku: product?.sku,
      page_id: pageId,
      bundle_name: null,
      total_discount: 0,
      currency: 'AED',
      product_type: type,
      product_name: product?.name,
      product_sku : productSku,
      delivery_promise: product?.deliverByV2 || product?.deliverBy || null,
      availability: product?.outOfStock ? 'out of stock' : 'in stock',
      express_availability: product?.express_bool || product?.express ? true : false,
      value: (parseFloat(price) || parseFloat(product?.special_price) || parseFloat(product?.price)) * qty || (parseFloat(price) || parseFloat(product?.special_price) || parseFloat(product?.price)),
      promotion_name: badgeContents?.length > 0 ? badgeContents : null,
      promotion_value_tag: product?.badgeDetails?.offerBadge ? `${product?.badgeDetails?.offerBadge}% Off!` : null,
      bundle_deal_availability: product?.isBundled ? true : false,
      myaster_category: 'epharmacy',
      referrer_page : referrer_page ? referrer_page : referrerPage,
      ...(serializedAppointment?.doctorSpecialty? { speciality: serializedAppointment?.doctorSpecialty?.toLowerCase() } : {}),
      ...(serializedAppointment?.consultationType  ? { appointment_mode : serializedAppointment?.consultationType?.toLowerCase() } : {}),
      ...(serializedAppointment?.doctorName ? { doctor_name: serializedAppointment?.doctorName?.toLowerCase() } : {}),
      ...(serializedAppointment?.facilityName ? { facility_name: serializedAppointment?.facilityName?.toLowerCase() } : {}),
    }
    let sphValue = [];

    if (sku?.leftOrDefault && !sku?.right) {
      sphValue.push(sku?.leftOrDefault?.displayText);
    } else if (sku?.leftOrDefault && sku?.right) {
      sphValue.push(sku?.leftOrDefault?.displayText);
      sphValue.push(sku?.right?.displayText);
    }
    if (type === 'optics') {
      params.sph_value = sphValue;
    }

    return params;
  };

  const addToCartEvents = (qty) => {
    if(!FBTProduct) {
      if(!productHasVariants && !bundleAddToCart) {
        dataLayerSendEvent('add_to_cart', getEventParams('Epharmacy',qty));
        sendEventToSmartLook('add_to_cart');
      }
    }
  };

  // useEffect(() => {
  //   if(addToCartEvent && !FBTProduct && !FillerProduct){
  //     if(!productHasVariants) {
  //       dataLayerSendEvent('add_to_cart', getEventParams('Epharmacy'));
  //       sendEventToSmartLook('add_to_cart');
  //     }
  //     setAddToCartEvent(false);
  //   }
  // }, [addToCartEvent, productHasVariants]);


  const sendAnalyticsData = (newQty = false, updateQty = false, oldQty = false) => {
    let badgeContents = getBadgeContent();

    if (product !== null) {
       if (oldQty > newQty) {
        sendRemoveFromCartEvent(
          { ...product, quantity: oldQty - newQty },
          {
            item_list_id: itemListId,
            item_list_name: itemListName,
            index,
            section_name: sectionName,
            page_type : pageType,
            screen_name: screenName,
            referrer_page: referrerPage,
            promotion_name: badgeContents?.length>0 ? badgeContents :null,
          },
        );
      }
    }
  };

  const getPrice = (qty) => {
    if(fromBundleComponent) {
      const selectedBundle = product?.tierPrices?.bundles?.find(bundle => bundle?.quantity === BundleOffer);
      if(selectedBundle) {
        return parseFloat(selectedBundle?.price || '');
      }
      return (parseFloat(product?.specialPrice) || parseFloat(price) || parseFloat(product?.price));
    }
    return (parseFloat(product?.specialPrice) || parseFloat(price) || parseFloat(product?.price));
  }

  /**
   * @description Here we are enable loader for 300 mili second and then trun off.
   * @param {*} sec
   */
  const addToCartApiCallForV2 = (params, oldQty) => {
    dispatch(addItemsToCart({
        params,
        onSuccess: (res) => {
        if (checkIfInCart) {
          checkIfInCart(params?.items?.[0]?.sku, []);
          setShowUpselling(true);
        }
        if (res?.message) {
          toast.warning(res?.message);
          setCartButtonLoading(false);
          setSelectedCartItem(0);
        } else {
          sendAnalyticsData(params?.items?.[0]?.quantity , false, oldQty);
          localStorage.setItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION, true);
          addToCartEvents(params?.items?.[0]?.quantity);
          checkAndUpdateOldCartId(res?.cart_id);
          if(isMyCartPage) {
            dispatch(updateUserCartData({body: res}));
            // TODO: Keeping this for reference. Will remove after testing
            // getCartInfos();
          }
            setCartButtonLoading(false);
            dispatch(setProductItemQtyMultiple([
              ...reducerItems, 
              { 
                item_id: params?.items?.[0]?.sku, 
                qty: params?.items?.[0]?.quantity,
                price: getPrice(),
              }
            ])
          );
          dispatch(setTotalQtyData(myCartTotalItems + params?.items?.[0]?.quantity ));
        }
      },
      onFailure: (err) => {
        setSelectedCartItem(0);
        setCartButtonLoading(false);
        if (err?.errorCode !== 401 && err?.data !== 'Invalid Guest Token') {
          const errAnalyticsParams = getCommonAnalyticsParams();
          errorHandlingEpharmacy(err, true,errAnalyticsParams?.screenName, errAnalyticsParams?.pageType);
        } else {
          toast.error(ADD_TO_CART_ERROR_MESSAGE);
        }
      },
    }));
  };

  /**
   * @description Here we have declare addItemToCart API to add item into the cart.
   */
  const addItemToCart = (value = null, productSku) => {
    if (router?.asPath?.includes('searchresult')) {
      triggerSearchtermApi(product);
    }
    setCartButtonLoading(true);
    const oldQty = selectedCartItem;
    if (sku) {
      const qty = value || (selectedCartItem > 0 ? selectedCartItem : 1);
      const { page, sub_type } = getPage(router?.asPath);
      const params = {
        cartType: CART_TYPES.AE,
        page,
        ...(sub_type && { sub_type }),
        items: [                                                                                                                              
          {
          "quantity": Number(qty),
          sku: productSku ? productSku : sku,
        },
      ]
      };
      if(enableXUserVcpId){
        params.userId = userLogin?.id
      }
      if (userZoneData) {
        params.zones = userZoneData;
      }
      if(isMyCartPage) {
        params.showCart = true;
      }
      if (getProductIndex) {
        getProductIndex(index, sku);
      }
      // if (!isMyCartPage) {
      setSelectedCartItem(qty);
      addToCartApiCallForV2(params, oldQty);
    }
  };

  useEffect(()=>{
    window.AddToCart = (productId, quantity) => {
      addItemToCart(quantity, productId);
    };
  },[]);

  const addMultipleItemsToCart = () => {
    const { page, sub_type } = getPage(router?.asPath);
    const params = {
      cartType: CART_TYPES.AE,
      page,
      ...(sub_type && { sub_type }),
      items: [],
    };

    if(enableXUserVcpId){
      params.userId = userLogin?.id
    }

    if (sku?.isDifferentSPH && (!sku?.leftOrDefault || !sku?.right)) {
      setErrors({
        ...errors,
        sph: {
          msg: 'Select Spherical (SPH) value',
          leftOrDefaultInvalid: !sku?.leftOrDefault,
          rightInvalid: !sku?.right,
        },
      });
      window?.scrollTo({ top: 200, left: 0, behavior: 'smooth' });
      return;
    }

    if (!sku?.leftOrDefault) {
      setErrors({
        ...errors,
        sph: { msg: 'Select Spherical (SPH) value', leftOrDefaultInvalid: true, rightInvalid: false },
      });
      window?.scrollTo({ top: 200, left: 0, behavior: 'smooth' });
      return;
    }

    setErrors({ ...errors, sph: null });
    params?.items?.push({ quantity: 1, sku: sku?.leftOrDefault?.sku });
    if (sku?.isDifferentSPH) {
      params?.items?.push({ quantity: 1, sku: sku?.right?.sku });
    }

    if (userZoneData) {
      params.zones = userZoneData;
    }
    if(isMyCartPage) {
      params.showCart = true;
    }

    setCartButtonLoading(true);
    dispatch(
      addItemsToCart({
        params,
        onSuccess: (res) => {
          setCartButtonLoading(false);
          if(res?.body?.message === ADD_TO_CART_MESSAGE){
            setShowUpselling(true);
          }
          if(res?.failed_skus?.length>0){
            setFailedToCart(true);
            toast.error(res?.message);
          } else if (res?.body?.message) {
            toast.warning(res?.body?.message);
            setSelectedCartItem(0);
          } else {
            localStorage.setItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION, true);
            callOpticsCartEvent();
            checkAndUpdateOldCartId(res?.cart_id);
            if(isMyCartPage) {
              // TODO: Keeping this for reference. Will remove after testing
              // getCartInfos();
              dispatch(updateUserCartData({body: res}));
            } 
              setCartButtonLoading(false);
              const updatedItems = params?.items?.map(item => {
                return { 
                  item_id: item?.sku, 
                  qty: item?.quantity,
                  price: getPrice(),
                }
              })
              dispatch(setProductItemQtyMultiple([
                ...reducerItems, 
                ...updatedItems
              ])
            );
            dispatch(setTotalQtyData(myCartTotalItems + updatedItems.reduce((tot, item) => tot + item.qty, 0) ));
          }
        },
        onFailure: (err) => {
          setCartButtonLoading(false);
          errorHandlingEpharmacy(err);
        },
      }),
    );
  };

  const updateCartApiCallForV2 = (params, incDecOperator, oldQty = null) => {
    setSelectedCartItem(params?.cartItem?.qty);
    setCartButtonLoading(true);
    dispatch(
      updateItemsInCart({
        params,
        onSuccess: (res) => {
          if (res?.data?.message === OUT_OF_STOCK_ERROR_MESSAGE) {
            setSelectedCartItem(oldQty);
            toast.warning(res?.data?.message);
          } else {
            sendAnalyticsData(params?.quantity, incDecOperator, oldQty);
            localStorage.setItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION, true);
          }
          checkAndUpdateOldCartId(res?.cart_id);
          if(isMyCartPage) {
            dispatch(updateUserCartData({body: res}));
            // TODO: Keeping this for reference. Will remove after testing
            // getCartInfos();
          } 
          setCartButtonLoading(false);
          const updatedItems = reducerItems.some(item => item.item_id === params?.sku)
            ? reducerItems.map(item =>
                item.item_id === params?.sku
                  ? { ...item, qty: params?.quantity, price: getPrice() }
                  : item
              )
            : [...reducerItems, { item_id: params?.sku, qty: params?.quantity, price: getPrice() }];
          const totalQty = updatedItems.reduce((total, item) => total + item.qty, 0);

          dispatch(setProductItemQtyMultiple(updatedItems));
        
          dispatch(setTotalQtyData(totalQty));
        },
        onFailure: (err) => {
          setSelectedCartItem(oldQty);
          setCartButtonLoading(false);
          if (err?.errorCode !== 401 && err?.data !== 'Invalid Guest Token') {
            const errAnalyticsParams = getCommonAnalyticsParams();
            errorHandlingEpharmacy(err, true,errAnalyticsParams?.screenName, errAnalyticsParams?.pageType);
          } else {
            toast.error(ADD_TO_CART_ERROR_MESSAGE);
          }
        },
      }),
    );
  };

  /**
   * @description Here we have declare updateCartItemQauntity API to update product cart item quantity.
   */
  const updateCartItemQauntity = (incDecOperator = null, newQty = null) => {
    if(productHasVariants) {
      callOpticsCartEvent();
    }
    const sessionCartId = sessionStorage.getItem(SESSION_STORAGE_KEYS.OLD_CART_ID);
    if (sku) {
      const oldQty = selectedCartItem;
      let qty = 0;
      if (newQty) {
        qty = newQty;
        dataLayerSendEvent('add_to_cart', getEventParams('Epharmacy',newQty));
        sendEventToSmartLook('add_to_cart');
      } else if (incDecOperator === '+') {
        qty = selectedCartItem + 1;
        dataLayerSendEvent('add_to_cart', getEventParams('Epharmacy',1));
        sendEventToSmartLook('add_to_cart');
        const qtyLength =
          Number(availableStock) > MAX_QTY_ADD_TO_CART_PER_ORDER
            ? MAX_QTY_ADD_TO_CART_PER_ORDER
            : Number(availableStock);
        if (qty > qtyLength) {
          toast.warning(OUT_OF_STOCK_ERROR_MESSAGE);
          return;
        }
      } else if (incDecOperator === '-') {
        qty = selectedCartItem - 1;
      }
      if (Number(oldQty) !== Number(qty)) {
        const { page } = getPage(router?.asPath);
        const params = {
            "sku": sku,
            quantity: Number(qty),
            cartId: !!cartData?.cart_id ? cartData?.cart_id : sessionCartId,
            page,
        };
        if(enableXUserVcpId){
          params.userId = userLogin?.id
        }
        if (userZoneData) {
          params.zones = userZoneData;
        }
        if(isMyCartPage) {
          params.showCart = true;
        }
        updateCartApiCallForV2(params, incDecOperator, oldQty);
      }
    } else if (incDecOperator === '+' && !isMyCartPage) {
      setSelectedCartItem(selectedCartItem + 1);
      const { page } = getPage(router?.asPath);
      const params = {
        "sku": sku,
        quantity: 1,
        cartId: !!cartData?.cart_id ? cartData?.cart_id : sessionCartId,
        page,
      };
      if(enableXUserVcpId){
        params.userId = userLogin?.id
      }
      if (userZoneData) {
        params.zones = userZoneData;
      }
      updateCartApiCallForV2(params, incDecOperator);
    }
  };

  const deleteItemsApiCallForV2 = (params) => {
    let badgeContents = getBadgeContent();

    setSelectedCartItem(0);
    dispatch(
      removeItemFromCart({
        params,
        onSuccess: (res) => {
          sendRemoveFromCartEvent(
            { ...product, quantity: selectedCartItem },
            {
              item_list_id: itemListId,
              item_list_name: itemListName,
              index,
              section_name: sectionName,
              page_type : pageType,
              screen_name: screenName,
              referrer_page: referrerPage,
              promotion_name: badgeContents?.length>0 ? badgeContents :null,
            },
          );
          checkAndUpdateOldCartId(res?.cart_id);
          localStorage.setItem(LOCALSTORAGE_KEYS.CART_ICON_ANIMATION, true);
          setSelectedCartItem(0);
          if(isMyCartPage) {
            dispatch(updateUserCartData({body: res}));
            // TODO: Keeping this for reference. Will remove after testing
            // getCartInfos();
          }
          setCartButtonLoading(false);
          const itemToRemove = reducerItems.find(item => item?.item_id === params?.sku);
          const removedQty = itemToRemove ? itemToRemove.qty : 0; 
          const updatedItems = reducerItems.filter(item => item?.item_id !== params?.sku)

          dispatch(setProductItemQtyMultiple(updatedItems));
          dispatch(setTotalQtyData(myCartTotalItems - removedQty));
          if (checkIfInCart) {
            checkIfInCart('', params?.sku);
          }
        },
        onFailure: (err) => {
          setCartButtonLoading(false);
          setSelectedCartItem(1);
          if (err?.errorCode !== 401 && err?.data !== 'Invalid Guest Token') {
            const errAnalyticsParams = getCommonAnalyticsParams();
            errorHandlingEpharmacy(err, true,errAnalyticsParams?.screenName, errAnalyticsParams?.pageType);
          } else {
            toast.error(ADD_TO_CART_ERROR_MESSAGE);
          }
        },
      }),
    );
  };
  /**
   * @description Here we have declare deleteProductItems API to delete the product from cart when item quantity is 1 and user click on minus button.
   */
  const deleteProductItems = () => {
    setCartButtonLoading(true);
    const sessionCartId = sessionStorage.getItem(SESSION_STORAGE_KEYS.OLD_CART_ID);
    if (sku !== null) {
      const params = {
        cartId: !!cartData?.cart_id ? cartData?.cart_id : sessionCartId,
        sku: sku,
      };
      if(enableXUserVcpId){
        params.userId = userLogin?.id
      }
      if (userZoneData) {
        params.zones = encodeURIComponent(JSON.stringify(userZoneData));
      }
      if(isMyCartPage) {
        params.showCart = true;
      }
      deleteItemsApiCallForV2(params);
    }
  };

  /**
   * @param {*} data
   * @description Here we will render dropdown item.
   * @returns Dropdown Item
   */
  const renderDropdownItem = (data) => {
    if (data?.length > 0) {
      return data?.map((item, i) => (
        <Dropdown.Item key={i} eventKey={item}>
          {(() => {
            if (data.length === i + 1) {
              return `${item} Max`;
            }
            return item;
          })()}
        </Dropdown.Item>
      ));
    }
    return (
      <Dropdown.Item eventKey="1" className="noData">
        No Data
      </Dropdown.Item>
    );
  };

  // TODO: this is commented for now. kept it for future reference
  // React.useEffect(() => {
  //   if (userLogin || guestLogin) {
  //     if (getCartV2Data && getCartV2Data === undefined) {
  //       getCartInfos();
  //     }
  //   }
  // }, [getCartV2Data, userLogin, guestLogin]);

  React.useEffect(() => {
    if (fromBundleComponent && BundleOffer) {
      addItemToCart(BundleOffer);
      setBundleOffer(null);
      setShowBundleSidebar(false);
    }
    if (closeBundle && valueDropDown > 0) {
      addItemToCart(valueDropDown);
      setShowBundleSidebar(false);
    } else if (closeBundle) {
      addItemToCart();
      setShowBundleSidebar(false);
    }
  }, [fromBundleComponent, BundleOffer, closeBundle]);

  const increaseProductClassName = () => {
    const qtyLength =
      Number(availableStock) > MAX_QTY_ADD_TO_CART_PER_ORDER ? MAX_QTY_ADD_TO_CART_PER_ORDER : Number(availableStock);
    if (cartButtonLoading || selectedCartItem >= qtyLength) {
      return 'opacity-50 cursor-pointer--not-allowed';
    }
  };

  const decreaseProductClassName = () => {
    if (cartButtonLoading || !sku) {
      return 'opacity-50 cursor-pointer--not-allowed';
    }
  };

  const handleProductViewDetails = () => {
    const asterBadge = product?.badgeDetails?.asterBadge;
    const lowestPriceLabel = product?.lowestPriceLabel;
    emptySphValues();

    let badgeContents = [];

    if (Array.isArray(asterBadge)) {
      badgeContents = asterBadge?.map((badge) => badge.content);
    } else if (asterBadge) {
      badgeContents = [asterBadge.content];
    }

    const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
    if (formattedLowestPriceLabel) {
      badgeContents.push(formattedLowestPriceLabel);
    }
    let ecommnerceData = [];
    if(sku?.isDifferentSPH) {
      ecommnerceData.push()
    }
    const params = {
      page_type: router?.asPath?.includes('searchresult') ? 'search result page' : 'product listing page',
      myaster_category: 'epharmacy',
      ecommerce: {
        items: [
          {
            ...getProductItemObjectEventFillersSelect(product),
          },
        ],
      },
      availability: !product?.inStock
        ? ASTER_PRODUCT_AVAILABILITY.OUT_OF_STOCK
        : ASTER_PRODUCT_AVAILABILITY.IN_STOCK,
      product_type: 'optics',
      product_sku: product?.sku,
      delivery_promise: product?.deliverByV2 || product?.deliverBy || null,
      express_availability:product?.express_bool ? 'true' : 'false',
      referrer_page: referrerPage,
      product_name: product?.name,
      screen_name: router?.pathname?.includes('searchresult') ?  'pharma search result' : screenName,
      page_id: pageId,
      bundle_deal_availability: product?.isBundled ? 'true' : 'false',
      promotion_name: badgeContents?.length>0 ? badgeContents :null,
      promotion_value_tag: product?.badgeDetails?.offerBadge ? `${product?.badgeDetails?.offerBadge}% Off!` : null,
      currency: getCurrency(getDataFromCookie('regionCode')),
    };
    dataLayerSendEvent('select_item', params);
    router.push({
      pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${product?.productUrl}`),
    });
  };

  const callOpticsCartEvent = () => {
    dataLayerSendEvent('add_to_cart', getEventParams('optics'));
  };

  const customAddToCartStyles = () => {
    const loading  = (outOfStock || cartButtonLoading || failedToCart);

    return {
      height: loading ? '43px' : '60px',
      width: loading ? '100px' : '60px',
      overflow: 'hidden',
      backgroundImage: `url(${product?.showViewDetails ? IC_CART_OPTICS.src : IC_CART.src})`,
      backgroundColor: 'transparent',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      objectFit: 'cover',
    };
  };
  
  if(!web_feature_flaging?.isCartEnable) {
    return <></>;
  }

  if (product?.showViewDetails && !outOfStock) {
    return (
      <div>
       {!newButton ?  <ButtonBase
          data-test="ViewDetailsButton"
          className="btn-cart"
          enableFullWidth={enableFullWidth}
          minWidth={minWidth}
          iconPosition="left"
          iconWidth="20px"
          iconHeight="20px"
          size={size}
          variant="outline-success"
          text="View Details"
          onClick={handleProductViewDetails}
        />  : 
        <div className="d-flex justify-content-center align-items-center w-100">
                <Button
                  disabled={outOfStock || cartButtonLoading || failedToCart}
                  className={`${ (outOfStock || cartButtonLoading || failedToCart) ? 'rounded-5 mb-2 d-flex align-items-center justify-content-center disabled-cart' : 'rounded-circle p-0 m-0 border-0 cart-icon'}`}
                  style={customAddToCartStyles(outOfStock, cartButtonLoading, failedToCart)}
                  onClick={handleProductViewDetails}
                >
                  {cartButtonLoading && 'Loading...'}
                </Button>
        </div>
        }
      </div>
    );
  }

  if (product?.notifyMe && outOfStock) {
    return (
      <div className="addToCartButtonWrapper">
        <div className={isFloat ? 'isFloat' : ''}>
          <NotifyMe
            userLogin={userLogin}
            outOfStock={outOfStock}
            enableFullWidth
            minWidth={minWidth}
            product={product}
            size={size}
            isPdpQuickView={shouldNotShowBundle}
            zoneData={zoneData}
            analyticsData={{
              screenName,
              pageType: pageType?.toLowerCase(),
              productName: product?.name,
              productSku: product?.sku,
              referrerPage: referrerpage,
            }}
            newButton={newButton}
          />
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    setFbt_addedtocart(true);
    setFilleraddedtocart(true);
    if (isBundle && !shouldNotShowBundle) {
      if (!dropdown2) {
        addItemToCart();
      } else {
        setShowBundleSidebar(true);
      }
    } else if (productHasVariants) {
      addMultipleItemsToCart();
    } else {
      addItemToCart();
    }
  };

  return (
    <div className="addToCartButtonWrapper">
      {(showBundleSidebar || (parseInt(valueDropDown) > 0 && parseInt(valueDropDown) <= lastQuantity && bundleflag)) && !shouldNotShowBundle &&
        dropdown2 && (
          <BundleOfferSideBar
            setBundleOffer={setBundleOffer}
            setcloseBundle={setcloseBundle}
            setfromBundleComponent={setfromBundleComponent}
            BundleImage={BundleImage}
            BundleDetails={BundleDetails}
            valueDropDown={valueDropDown}
            productDetails={productDetails}
            showBundleSidebar={showBundleSidebar}
            screenName={screenName}
            pageId={pageId}
            referrerpage={referrerpage}
            productName={productName}
            sku={sku}
            pageType={pageType}
            product={product}
            index={index}
            sectionName={sectionName}
            setBundleAddToCart={setBundleAddToCart}
          />
        )}
      {selectedCartItem > 0 && availableStock > 0 && !productHasVariants ? (
        <Col>
          <div className="quantity-wrapper">
            <DropdownControl
              appVariant={`epharmacy ${(() => {
                if (cartButtonLoading) {
                  return 'txtLoading';
                }
              })()}`}
              renderDropdownItem={renderDropdownItem}
              disabled={outOfStock}
              enableFullWidth
              theme="dropdown-wrapper"
              caption={cartButtonLoading ? <div className="txtLoading">{t('EPharmacyCheckout.securePointLoading')}</div> : selectedCartItem.toString()}
              data={itemQuantity}
              handleSelect={(value) => {
                setvalueDropDown(value);
                setDropdown2(false);
                if (isBundle && !closeBundle && !shouldNotShowBundle) {
                  if (parseInt(value) > lastQuantity) {
                    updateCartItemQauntity(null, value);
                  } else {
                    // setvalueDropDown(value);
                    setShowBundleSidebar(false);
                    updateCartItemQauntity(null, value);
                  }
                } else {
                  updateCartItemQauntity(null, value);
                }
              }}
              data-test="quantityDropdown"
            />
            <div
              className="decrease-product"
              style={{
                pointerEvents: isFirstElement && selectedCartItem === 1 ? 'none' : 'auto',
                opacity: isFirstElement && selectedCartItem === 1 ? 0.5 : 1,
              }}
            >
              <Image
                src={Number(selectedCartItem) <= 1 ? IC_REMOVE : IC_NEW_DECREASE_PRODUCT.src}
                alt="Product Qty Decrease"
                className={decreaseProductClassName()}
                data-test="decreaseProductQty"
                onClick={() => {
                  setFbt_addedtocart(false);
                  setBundleAddToCart(false);
                  if (!cartButtonLoading && sku !== null) {
                    if (Number(selectedCartItem) <= 1) {
                      setvalueDropDown(0);
                      setcloseBundle(false);
                      deleteProductItems();
                      setDropdown2(true);
                    } else {
                      updateCartItemQauntity('-');
                      setvalueDropDown(valueDropDown - 1);
                    }
                  }
                }}
                width="40px"
                height="40px"
              />
            </div>
            <div className="increase_product">
              <Image
                src={IC_NEW_INCREASE_PRODUCT.src}
                alt="Product Qty Increase"
                className={increaseProductClassName()}
                data-test="increaseProductQty"
                onClick={() => {
                  setBundleAddToCart(false);
                  setFbt_addedtocart(false);
                  setFilleraddedtocart(false);
                  const asterBadge = product?.badgeDetails?.asterBadge;
                  const lowestPriceLabel = product?.lowestPriceLabel;

                  let badgeContents = [];

                  if (Array.isArray(asterBadge)) {
                    badgeContents = asterBadge?.map((badge) => badge.content);
                  } else if (asterBadge) {
                    badgeContents = [asterBadge.content];
                  }

                  const formattedLowestPriceLabel = lowestPriceLabel?.replace(/<\/?b>/g, '');
                  if (formattedLowestPriceLabel) {
                    badgeContents.push(formattedLowestPriceLabel);
                  }
                  // dataLayerSendEvent('add_to_cart', {
                  //   ecommerce: {
                  //     items: product ? [{ ...getProductItemObjectEventFillers(product), index: index +1 }] : []
                  //   },
                  //   section_name:  sectionName==="Product Details Page - FBT" || sectionName=== "Product Listing page" ? null : sectionName,
                  //   screen_name: screenName,
                  //   page_type:pageType?.toLowerCase(),
                  //   page_id: pageId,
                  //   bundle_name: null,
                  //   total_discount:0,
                  //   currency :"AED",
                  //   delivery_promise: product?.deliverBy ? product?.deliverBy : null,
                  //   availability: product?.outOfStock  ? "out of stock" : "in stock",
                  //   express_availability: product?.express_bool || product?.express ? true : false,
                  //   value:parseFloat(price) || parseFloat(product?.special_price) || parseFloat(product?.price),
                  //   promotion_name: badgeContents?.length>0 ? badgeContents :null,
                  //   promotion_value_tag: product?.badgeDetails?.offerBadge ? `${product?.badgeDetails?.offerBadge}% Off!` : null,
                  //   bundle_deal_availability: product?.isBundled ? true : false,
                  //   referrer_page: referrerpage,
                  //   myaster_category: 'epharmacy',
                  // });
                  // sendEventToSmartLook('add_to_cart');
                  setDropdown2(false);
                  let isDisabled = false;
                  const qtyLength =
                    Number(availableStock) > MAX_QTY_ADD_TO_CART_PER_ORDER
                      ? MAX_QTY_ADD_TO_CART_PER_ORDER
                      : Number(availableStock);
                  if ((isMyCartPage && cartButtonLoading) || selectedCartItem >= qtyLength) {
                    isDisabled = true;
                  }
                  if (!itemQuantity <= 0 && !cartButtonLoading && !isDisabled) {
                    if (outOfStock) {
                      toast.warning(OUT_OF_STOCK_ERROR_MESSAGE);
                    } else if (
                      Number(selectedCartItem) === MAX_QTY_ADD_TO_CART_PER_ORDER ||
                      Number(selectedCartItem) === Number(itemQuantity?.length)
                    ) {
                      toast.warning(`You've reached maximum limit`);
                    } else {
                      updateCartItemQauntity('+');
                      setvalueDropDown(valueDropDown + 1);
                    }
                  }
                }}
                width="40px"
                height="40px"
              />
            </div>
          </div>
        </Col>
      ) : (
        <>
          {!productHasVariants && (
            <div className="quantity-wrapper-small pe-0" style={{marginLeft: cartButtonLoading && window?.innerWidth >= MIN_MOBILE_WIDTH ? "-120px" : cartButtonLoading && window?.innerWidth <= MIN_MOBILE_WIDTH ? "-90px" : 0}}>
              {(() => {
                if (isProductDetails && !cartButtonLoading) {
                  return (
                    <DropdownControl
                      appVariant="epharmacy"
                      renderDropdownItem={renderDropdownItem}
                      disabled={outOfStock}
                      enableFullWidth
                      theme="dropdown-wrapper"
                      caption={selectedCartItem > 0 ? selectedCartItem : 1}
                      data={itemQuantity}
                      handleSelect={(value) => {
                        setvalueDropDown(value);
                        if (isBundle && !closeBundle && !shouldNotShowBundle) {
                          // setvalueDropDown(value);
                          if (parseInt(value) > lastQuantity) {
                            addItemToCart(value);
                          } else {
                            // setvalueDropDown(value);
                            setShowBundleSidebar(true);
                          }
                        } else {
                          addItemToCart(value);
                        }
                      }}
                      data-testid="quantityDropdown"
                    />
                  );
                }
              })()}
            </div>
          )}
          <div className={isFloat ? 'isFloat' : ''}>
            {!newButton ? (
              <ButtonBase
                data-test="AddToCartButton"
                disabled={outOfStock || cartButtonLoading || failedToCart}
                className="btn-cart"
                enableFullWidth={enableFullWidth}
                minWidth={minWidth}
                iconPosition="left"
                iconWidth="20px"
                iconHeight="20px"
                size={size}
                variant={isProductDetails ? 'success' : 'outline-success'}
                text={(() => {
                  if (cartButtonLoading) {
                    return t('EPharmacyCheckout.securePointLoading');
                  }
                  return t('EPharmacyCheckout.addToCart');
                })()}
                onClick={handleAddToCart}
              />
            ) : (
              <div className="d-flex justify-content-center align-items-center w-100">
                <Button
                  disabled={outOfStock || cartButtonLoading || failedToCart}
                  className={`${ (outOfStock || cartButtonLoading || failedToCart) ? 'rounded-5 mb-2 d-flex align-items-center justify-content-center disabled-cart' : 'rounded-circle p-0 m-0 border-0 cart-icon'}`}
                  style={customAddToCartStyles(outOfStock, cartButtonLoading, failedToCart)}
                  onClick={handleAddToCart}
                >
                  {cartButtonLoading && t('EPharmacyCheckout.securePointLoading')}
                </Button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

AddToCart.propTypes = {
  isProductDetails: PropTypes.bool,
  availableStock: PropTypes.number,
  sku: PropTypes.string,
  outOfStock: PropTypes.bool,
  product: PropTypes.object,
  size: PropTypes.string,
  enableFullWidth: PropTypes.bool,
  minWidth: PropTypes.string,
  isFloat: PropTypes.bool,
  pageType: PropTypes.string,
  sectionName: PropTypes.string,
  isMyCartPage: PropTypes.bool,
  itemListId: PropTypes.string,
  itemListName: PropTypes.string,
  index: PropTypes.number,
  getProductIndex: PropTypes.func,
  checkIfInCart: PropTypes.func,
  setShowUpselling: PropTypes.func,
  isBundle: PropTypes.bool,
  bundleflag: PropTypes.bool,
  setErrors: PropTypes.func,
  errors: PropTypes.object,
  FBTProduct: PropTypes.bool,
  newButton: PropTypes.bool,
  isOptics: PropTypes.bool,
};

AddToCart.defaultProps = {
  isProductDetails: false,
  isBundle: false,
  availableStock: 0,
  sku: '',
  outOfStock: false,
  product: {},
  size: 'sm',
  enableFullWidth: false,
  minWidth: '140px',
  isFloat: false,
  pageType: '',
  sectionName: '',
  isMyCartPage: false,
  itemListId: '',
  itemListName: '',
  index: 0,
  bundleflag: false,
  errors: {},
  FBTProduct: false,
  newButton: false,
  isOptics: false, 
  checkIfInCart: () => {},
  getProductIndex: () => {},
  setShowUpselling: () => {},
  setErrors: () => {},
  setFbt_addedtocart: () => {},
  setFilleraddedtocart: () => {}
};

export default AddToCart;
